/* <read-more> — clamps long rich text and reveals a "Mehr lesen" toggle only
   when the content actually overflows. Degrades gracefully: without JS the
   content shows in full and the button stays hidden.

   Markup:
   <read-more>
     <div data-rm-content>…long content…</div>
     <button type="button" data-rm-toggle hidden aria-expanded="false">…</button>
   </read-more>
*/
class ReadMore extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector('[data-rm-content]');
    const toggle = this.querySelector('[data-rm-toggle]');
    if (!content || !toggle) return;

    const threshold = parseInt(this.dataset.maxHeight || '170', 10);

    requestAnimationFrame(() => {
      // Measured before any clamp is applied, so this is the natural height.
      if (content.scrollHeight > threshold + 8) {
        this.classList.add('is-clamped');
        toggle.hidden = false;
      }
    });

    toggle.addEventListener('click', () => {
      const expanded = this.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
